import axiosInstance from './axiosInstance';
import { userApi } from './userService';
import { videoApi } from './videoService';
import { auditApi } from './auditService';
import { taskApi } from './taskService';
import { matchApi } from './matchService';

// 文档解析相关API
const pdfApi = {
  // 获取PDF文件列表
  getFiles: async (params) => {
    try {
      const response = await axiosInstance.get('pdf/files', { params });
      // 确保返回正确的数据格式
      if (response.data && response.data.code === 0) {
        return response.data.data;
      } else if (response.data && Array.isArray(response.data.items)) {
        return {
          items: response.data.items,
          total: response.data.total || response.data.items.length
        };
      } else if (Array.isArray(response.data)) {
        return {
          items: response.data,
          total: response.data.length
        };
      }
      throw new Error('响应数据格式错误');
    } catch (error) {
      console.error('获取文件列表失败:', error);
      throw new Error(error.response?.data?.message || '获取文件列表失败');
    }
  },
  
  // 上传PDF文件
  uploadFile: (file, subject, contentType) => {
    const formData = new FormData();
    formData.append('file', file);
    if (subject) {
      formData.append('subject', subject);
    }
    if (contentType) {
      formData.append('content_type', contentType);
    }
    
    const token = localStorage.getItem('token');
    if (!token) {
      throw new Error('未登录或登录已过期');
    }
    
    return axiosInstance.post('pdf/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': token,
        'Accept': 'application/json'
      },
      timeout: 300000, // 300秒(5分钟)超时
      onUploadProgress: (progressEvent) => {
        //console.log('上传进度：', progressEvent.loaded / progressEvent.total * 100);
      }
    });
  },
  
  // 获取文件详情
  getFile: (id) => axiosInstance.get(`pdf/files/${id}`),
  
  // 获取文件的签名URL
  getSignedUrl: (id) => axiosInstance.get(`pdf/files/${id}/signed-url`),
  
  // 更新PDF提取内容
  updateContent: (id, content) => axiosInstance.put(`pdf/files/${id}/content`, { content }),
  
  // 更新PDF匹配状态
  updateMatchStatus: (id, status) => axiosInstance.put(`pdf/files/${id}/match-status`, { status }),
  
  // 开始提取
  startExtract: (id, subject) => axiosInstance.post(`pdf/files/${id}/extract`, { subject }),
  
  // 获取提取状态
  getExtractStatus: (id) => axiosInstance.get(`pdf/files/${id}/progress`),
  
  // 获取提取结果
  getExtractResult: (id) => axiosInstance.get(`pdf/files/${id}/extract-result`),
  
  // 获取提取日志
  getExtractLogs: (id) => axiosInstance.get(`pdf/files/${id}/extract-logs`),
  
  // 重新提取
  retryExtract: (id) => axiosInstance.post(`pdf/files/${id}/retry-extract`),
  
  // 取消提取
  cancelExtract: (id) => axiosInstance.post(`pdf/files/${id}/cancel-extract`),
  
  // 删除文件
  deleteFile: (id) => axiosInstance.delete(`pdf/files/${id}`),
  
  // 批量删除文件
  batchDeleteFiles: (ids) => axiosInstance.post('pdf/files/batch-delete', { ids }),
  
  // 获取文件列表（带过滤和排序）
  getFilesWithFilters: async (filters = {}, sort = {}, page = 1, pageSize = 10) => {
    const queryParams = new URLSearchParams();
    
    // 添加过滤条件
    if (filters.keyword) queryParams.append('keyword', filters.keyword);
    if (filters.status) queryParams.append('status', filters.status);
    if (filters.subject) queryParams.append('subject', filters.subject);
    if (filters.course) queryParams.append('course', filters.course);
    if (filters.startDate) queryParams.append('start_date', filters.startDate);
    if (filters.endDate) queryParams.append('end_date', filters.endDate);
    
    // 添加排序条件
    if (sort.field) queryParams.append('order_by', sort.field);
    if (sort.direction) queryParams.append('order_direction', sort.direction);
    
    // 添加分页参数
    queryParams.append('page', page);
    queryParams.append('page_size', pageSize);
    
    const response = await axiosInstance.get(`pdf/files?${queryParams.toString()}`);
    return response.data;
  }
};

// 导出所有API
export {
  userApi,
  videoApi,
  auditApi,
  taskApi,
  matchApi,
  pdfApi
};

export default axiosInstance; 